(() => {
  let pending = false;
  const update = async (input, quantity) => {
    if (pending || !Number.isInteger(quantity) || quantity < 0) return;
    const drawer = input.closest('cart-drawer');
    const oldValue = input.defaultValue;
    pending = true;
    drawer.setAttribute('aria-busy', 'true');
    drawer.querySelectorAll('button, input').forEach(el => el.disabled = true);
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(input.dataset.index), quantity, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
      });
      const cart = await response.json();
      if (!response.ok || cart.errors) throw new Error(cart.description || cart.errors || 'Unable to update cart. Please try again.');
      const doc = new DOMParser().parseFromString(cart.sections['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('#CartDrawer');
      if (!fresh) { window.location.reload(); return; }
      drawer.querySelector('#CartDrawer').innerHTML = fresh.innerHTML;
      drawer.classList.toggle('is-empty', cart.item_count === 0);
      const bubble = document.getElementById('cart-icon-bubble');
      const bubbleDoc = new DOMParser().parseFromString(cart.sections['cart-icon-bubble'], 'text/html');
      bubble.innerHTML = bubbleDoc.querySelector('.shopify-section').innerHTML;
      drawer.querySelector('.drawer__inner').focus();
    } catch (error) {
      input.value = oldValue;
      let message = drawer.querySelector('[data-paws-cart-error]');
      if (!message) {
        message = document.createElement('p');
        message.dataset.pawsCartError = '';
        message.setAttribute('role', 'alert');
        drawer.querySelector('.drawer__inner').append(message);
      }
      message.textContent = error.message;
    } finally {
      pending = false;
      drawer.removeAttribute('aria-busy');
      drawer.querySelectorAll('button, input').forEach(el => el.disabled = false);
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('cart-drawer .quantity__button, cart-drawer cart-remove-button');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const row = button.closest('[data-index][role="row"]');
    const input = row && row.querySelector('input[name="updates[]"]');
    if (!input) return;
    const quantity = button.matches('cart-remove-button') ? 0 : Math.max(0, Number(input.value) + (button.name === 'plus' ? 1 : -1));
    update(input, quantity);
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.matches('cart-drawer input[name="updates[]"]')) return;
    event.stopImmediatePropagation();
    update(event.target, Number(event.target.value));
  }, true);
})();
